/* hesatek-native-cart-drawer-v1 */
(function () {
  'use strict';

  function initHesatekCartDrawer() {
    var drawer = document.getElementById('mini-cart');

    if (!drawer || !drawer.classList.contains('hesatek-cart-drawer')) {
      return;
    }

    // The Kaktus embed injects a late !important rule that hides Warehouse's
    // native .mini-cart. An inline important declaration keeps the preview
    // drawer renderable while the app remains installed for rollback.
    drawer.style.setProperty('display', 'block', 'important');
    drawer.style.setProperty('z-index', '2147483647', 'important');
    drawer.style.setProperty('opacity', '1', 'important');
    drawer.style.setProperty('transform', 'none', 'important');
    drawer.style.setProperty('transition', 'none', 'important');

    var root = document.documentElement;
    var cartHost = drawer.closest('.header__action-item--cart');
    var lastTrigger = null;
    var pendingOperations = 0;
    var operationQueue = Promise.resolve();
    var openTimer = null;
    var closeTimer = null;
    var pickerCloseTimer = null;
    var pickerTrigger = null;
    var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var openDuration = reduceMotion ? 1 : 200;
    var backdropDuration = reduceMotion ? 1 : 140;
    var pickerDuration = reduceMotion ? 1 : 180;
    var recommendationFeedbackDuration = reduceMotion ? 180 : 420;

    // Keep a reference to Warehouse's cart host for its rerender event, then
    // portal the dialog to body. This prevents header stacking contexts and
    // header-wide interaction styles from sitting above or leaking into it.
    if (drawer.parentElement !== document.body) {
      document.body.appendChild(drawer);
    }

    function getHeaderTriggers() {
      return Array.prototype.filter.call(
        document.querySelectorAll('[aria-controls="mini-cart"]'),
        function (element) {
          return !drawer.contains(element);
        }
      );
    }

    function isCartInteractiveTarget(target) {
      return target && target.closest && target.closest(
        '.header__cart-toggle, .hesatek-cart-drawer a, .hesatek-cart-drawer button, ' +
        '.hesatek-cart-drawer input, .hesatek-cart-drawer select'
      );
    }

    function markPointerInput(event) {
      if (isCartInteractiveTarget(event.target)) {
        root.classList.add('hesatek-cart-pointer-input');
      }
    }

    document.addEventListener('pointerdown', markPointerInput, true);

    if (!window.PointerEvent) {
      document.addEventListener('touchstart', markPointerInput, true);
    }

    document.addEventListener('keydown', function () {
      root.classList.remove('hesatek-cart-pointer-input');
    }, true);

    function setBusy(isBusy) {
      drawer.setAttribute('aria-busy', isBusy ? 'true' : 'false');
    }

    function getPicker() {
      return drawer.querySelector('[data-hesatek-cart-picker-content]') &&
        drawer.querySelector('#hesatek-cart-recommendation-picker');
    }

    function isPickerOpen() {
      var picker = getPicker();
      return Boolean(picker && !picker.hidden && picker.getAttribute('aria-hidden') === 'false');
    }

    function setMainViewInactive(isInactive) {
      var mainView = drawer.querySelector('[data-hesatek-cart-main-view]');

      if (!mainView) {
        return;
      }

      if (isInactive) {
        mainView.setAttribute('aria-hidden', 'true');
        mainView.setAttribute('inert', '');
        if ('inert' in mainView) {
          mainView.inert = true;
        }
      } else {
        mainView.removeAttribute('aria-hidden');
        mainView.removeAttribute('inert');
        if ('inert' in mainView) {
          mainView.inert = false;
        }
      }
    }

    function setPickerHeader(isOpen) {
      var back = drawer.querySelector('[data-hesatek-cart-picker-back]');
      var mainTitle = drawer.querySelector('[data-hesatek-cart-main-title]');
      var pickerTitle = drawer.querySelector('[data-hesatek-cart-picker-title]');

      if (back) {
        back.hidden = !isOpen;
      }
      if (mainTitle) {
        mainTitle.hidden = isOpen;
      }
      if (pickerTitle) {
        pickerTitle.hidden = !isOpen;
      }
    }

    function numberAttribute(element, name, fallbackValue) {
      if (!element) {
        return fallbackValue;
      }

      var rawValue = element.getAttribute(name);
      if (rawValue === null || rawValue === '') {
        return fallbackValue;
      }

      var parsedValue = Number(rawValue);
      return Number.isFinite(parsedValue) ? parsedValue : fallbackValue;
    }

    function pickerQuantityRules(variant) {
      var minimum = Math.max(1, Math.floor(numberAttribute(variant, 'data-quantity-min', 1)));
      var increment = Math.max(1, Math.floor(numberAttribute(variant, 'data-quantity-increment', 1)));
      var ruleMaximum = numberAttribute(variant, 'data-quantity-max', Infinity);
      var inventoryMaximum = Infinity;
      var tracksInventory = Boolean(variant && variant.getAttribute('data-inventory-management'));
      var deniesOverselling = variant && variant.getAttribute('data-inventory-policy') === 'deny';

      if (tracksInventory && deniesOverselling) {
        inventoryMaximum = Math.max(0, Math.floor(numberAttribute(variant, 'data-inventory-quantity', 0)));
      }

      var effectiveMaximum = Math.min(ruleMaximum, inventoryMaximum);
      var usableMaximum = Infinity;

      if (Number.isFinite(effectiveMaximum) && effectiveMaximum >= minimum) {
        usableMaximum = minimum + Math.floor((effectiveMaximum - minimum) / increment) * increment;
      } else if (Number.isFinite(effectiveMaximum)) {
        usableMaximum = effectiveMaximum;
      }

      return {
        increment: increment,
        maximum: usableMaximum,
        minimum: minimum,
        valid: !Number.isFinite(usableMaximum) || usableMaximum >= minimum
      };
    }

    function selectedPickerVariant() {
      var picker = getPicker();
      return picker && picker.querySelector('[data-hesatek-cart-picker-variant]:checked');
    }

    function clearPickerError() {
      var picker = getPicker();
      var error = picker && picker.querySelector('[data-hesatek-cart-picker-error]');

      if (error) {
        error.textContent = '';
        error.hidden = true;
      }
    }

    function syncPickerQuantity(resetToMinimum) {
      var picker = getPicker();
      var variant = selectedPickerVariant();
      var input = picker && picker.querySelector('[data-hesatek-cart-picker-quantity]');
      var decrease = picker && picker.querySelector('[data-hesatek-cart-picker-decrease]');
      var increase = picker && picker.querySelector('[data-hesatek-cart-picker-increase]');
      var confirm = picker && picker.querySelector('[data-hesatek-cart-picker-confirm]');

      if (!picker || !variant || !input || !decrease || !increase || !confirm) {
        if (input) {
          input.disabled = true;
          input.setAttribute('aria-invalid', 'false');
          input.removeAttribute('aria-valuenow');
          input.removeAttribute('aria-valuemax');
        }
        if (decrease) {
          decrease.disabled = true;
        }
        if (increase) {
          increase.disabled = true;
        }
        if (confirm) {
          confirm.disabled = true;
        }
        return;
      }

      var rules = pickerQuantityRules(variant);
      var requested = resetToMinimum ? rules.minimum : Math.floor(Number(input.value));

      if (!Number.isFinite(requested)) {
        requested = rules.minimum;
      }

      requested = Math.max(rules.minimum, requested);
      requested = rules.minimum + Math.floor((requested - rules.minimum) / rules.increment) * rules.increment;

      if (Number.isFinite(rules.maximum)) {
        requested = Math.min(requested, rules.maximum);
      }

      if (!rules.valid) {
        requested = rules.minimum;
      }

      input.value = String(requested);
      input.setAttribute('role', 'spinbutton');
      input.setAttribute('min', String(rules.minimum));
      input.setAttribute('step', String(rules.increment));
      input.setAttribute('aria-valuemin', String(rules.minimum));
      input.setAttribute('aria-valuenow', String(requested));
      input.disabled = !rules.valid;
      input.setAttribute('aria-invalid', rules.valid ? 'false' : 'true');

      if (Number.isFinite(rules.maximum)) {
        input.setAttribute('max', String(rules.maximum));
        input.setAttribute('aria-valuemax', String(rules.maximum));
      } else {
        input.removeAttribute('max');
        input.removeAttribute('aria-valuemax');
      }

      decrease.disabled = !rules.valid || requested <= rules.minimum;
      increase.disabled = !rules.valid ||
        (Number.isFinite(rules.maximum) && requested + rules.increment > rules.maximum);
      var quantityLabel = picker.querySelector('.hesatek-cart-picker__quantity-label');
      quantityLabel = quantityLabel ? quantityLabel.textContent.trim() : 'Quantity';
      decrease.setAttribute('aria-label', quantityLabel + ' − ' + rules.increment);
      increase.setAttribute('aria-label', quantityLabel + ' + ' + rules.increment);
      confirm.disabled = !rules.valid;
      confirm.setAttribute('data-variant-id', variant.value);
      confirm.setAttribute('data-quantity', String(requested));

      var addLabel = confirm.getAttribute('data-add-label') || confirm.textContent.trim();
      var choiceTitle = variant.closest('label');
      choiceTitle = choiceTitle && choiceTitle.querySelector('.hesatek-cart-picker__choice-title');
      confirm.setAttribute(
        'aria-label',
        addLabel + (choiceTitle ? ': ' + choiceTitle.textContent.trim() : '') +
          ', ' + quantityLabel + ' ' + requested
      );
      clearPickerError();
    }

    function adjustPickerQuantity(direction) {
      var pickerQuantity = drawer.querySelector('[data-hesatek-cart-picker-quantity]');
      var pickerVariant = selectedPickerVariant();

      if (!pickerQuantity || !pickerVariant) {
        return;
      }

      var pickerRules = pickerQuantityRules(pickerVariant);
      var currentQuantity = Number(pickerQuantity.value);
      if (!Number.isFinite(currentQuantity)) {
        currentQuantity = pickerRules.minimum;
      }

      pickerQuantity.value = String(currentQuantity + direction * pickerRules.increment);
      syncPickerQuantity(false);
    }

    function openRecommendationPicker(trigger) {
      if (pendingOperations > 0) {
        return;
      }

      var recommendation = trigger && trigger.closest('.hesatek-cart-recommendations__item');
      var template = recommendation && recommendation.querySelector('[data-hesatek-cart-recommendation-template]');
      var picker = getPicker();
      var content = picker && picker.querySelector('[data-hesatek-cart-picker-content]');

      if (!template || !picker || !content) {
        return;
      }

      window.clearTimeout(pickerCloseTimer);

      if (pickerTrigger && pickerTrigger !== trigger && document.contains(pickerTrigger)) {
        pickerTrigger.setAttribute('aria-expanded', 'false');
      }

      pickerTrigger = trigger;
      pickerTrigger.setAttribute('aria-expanded', 'true');
      content.replaceChildren(template.content.cloneNode(true));
      setMainViewInactive(true);
      setPickerHeader(true);
      drawer.classList.add('hesatek-cart-drawer--picker-open');
      picker.hidden = false;
      picker.setAttribute('aria-hidden', 'false');
      syncPickerQuantity(true);

      window.requestAnimationFrame(function () {
        picker.classList.add('is-open');
        window.requestAnimationFrame(function () {
          var variant = selectedPickerVariant() || picker.querySelector('[data-hesatek-cart-picker-variant]');
          var back = drawer.querySelector('[data-hesatek-cart-picker-back]');
          var initialFocus = variant || back;
          if (initialFocus) {
            initialFocus.focus({ preventScroll: true });
          }
        });
      });
    }

    function closeRecommendationPicker(restoreFocus, immediate) {
      var picker = getPicker();
      var content = picker && picker.querySelector('[data-hesatek-cart-picker-content]');
      var trigger = pickerTrigger;

      window.clearTimeout(pickerCloseTimer);

      if (trigger && document.contains(trigger)) {
        trigger.setAttribute('aria-expanded', 'false');
      }

      pickerTrigger = null;
      drawer.classList.remove('hesatek-cart-drawer--picker-open');
      setPickerHeader(false);
      setMainViewInactive(false);

      if (picker) {
        picker.classList.remove('is-open');
        picker.setAttribute('aria-hidden', 'true');
      }

      function finishClose() {
        if (picker) {
          picker.hidden = true;
        }
        if (content) {
          content.replaceChildren();
        }
      }

      if (immediate) {
        finishClose();
      } else {
        pickerCloseTimer = window.setTimeout(finishClose, pickerDuration);
      }

      if (restoreFocus && trigger && document.contains(trigger)) {
        window.requestAnimationFrame(function () {
          trigger.focus({ preventScroll: true });
        });
      }
    }

    function focusInitialControl() {
      window.requestAnimationFrame(function () {
        var initialFocus = isPickerOpen()
          ? drawer.querySelector('[data-hesatek-cart-picker-back]')
          : drawer.querySelector('[data-hesatek-cart-initial-focus]');

        if (initialFocus) {
          initialFocus.focus({ preventScroll: true });
        }
      });
    }

    function visualElements() {
      return {
        panel: drawer.querySelector('.hesatek-cart-drawer__panel'),
        backdrop: drawer.querySelector('.hesatek-cart-drawer__backdrop')
      };
    }

    function setVisualRestingState(isOpen) {
      var elements = visualElements();

      if (elements.panel) {
        elements.panel.style.setProperty('transition', 'none', 'important');
        elements.panel.style.setProperty('transform', isOpen ? 'translateX(0)' : 'translateX(100%)', 'important');
      }

      if (elements.backdrop) {
        elements.backdrop.style.setProperty('transition', 'none', 'important');
        elements.backdrop.style.setProperty('opacity', isOpen ? '1' : '0', 'important');
      }
    }

    function syncOpenState(shouldFocus) {
      var isOpen = drawer.getAttribute('aria-hidden') === 'false';

      drawer.style.setProperty('visibility', isOpen ? 'visible' : 'hidden', 'important');
      drawer.style.setProperty('pointer-events', isOpen ? 'auto' : 'none', 'important');
      root.classList.toggle('hesatek-cart-drawer-open', isOpen);
      document.body.classList.toggle('no-mobile-scroll', isOpen);

      getHeaderTriggers().forEach(function (trigger) {
        trigger.setAttribute('aria-expanded', isOpen ? 'true' : 'false');

        var icon = trigger.querySelector('.header__cart-icon');
        if (icon) {
          // The controlling link owns expanded state; its decorative span does not.
          icon.removeAttribute('aria-expanded');
        }
      });

      if (!isOpen) {
        return;
      }

      if (shouldFocus) {
        focusInitialControl();
      }
    }

    function openDrawer(trigger) {
      if (drawer.getAttribute('aria-hidden') === 'false') {
        return;
      }

      window.clearTimeout(closeTimer);
      window.clearTimeout(openTimer);
      lastTrigger = trigger || document.activeElement;
      setVisualRestingState(false);
      drawer.setAttribute('aria-hidden', 'false');
      syncOpenState(false);

      var elements = visualElements();
      if (!elements.panel || !elements.backdrop) {
        focusInitialControl();
        return;
      }

      // Force a painted off-canvas frame before starting the transition. This
      // prevents the late Kaktus styles from collapsing the animation.
      elements.panel.getBoundingClientRect();
      window.requestAnimationFrame(function () {
        elements.panel.style.setProperty(
          'transition',
          'transform ' + openDuration + 'ms cubic-bezier(0.22, 1, 0.36, 1)',
          'important'
        );
        elements.backdrop.style.setProperty(
          'transition',
          'opacity ' + backdropDuration + 'ms ease',
          'important'
        );
        elements.panel.style.setProperty('transform', 'translateX(0)', 'important');
        elements.backdrop.style.setProperty('opacity', '1', 'important');
        focusInitialControl();

        // Settle to a transition-free final state after the motion window. It
        // is visually identical after a normal transition and prevents a
        // third-party transition rule from leaving the panel off canvas.
        openTimer = window.setTimeout(function () {
          if (drawer.getAttribute('aria-hidden') === 'false') {
            setVisualRestingState(true);
          }
        }, openDuration + 48);
      });
    }

    function closeDrawer(restoreFocus) {
      if (drawer.getAttribute('aria-hidden') === 'true') {
        return;
      }

      closeRecommendationPicker(false, true);

      var elements = visualElements();
      window.clearTimeout(openTimer);
      window.clearTimeout(closeTimer);

      if (elements.panel && elements.backdrop) {
        elements.panel.style.setProperty(
          'transition',
          'transform ' + openDuration + 'ms cubic-bezier(0.4, 0, 1, 1)',
          'important'
        );
        elements.backdrop.style.setProperty(
          'transition',
          'opacity ' + backdropDuration + 'ms ease',
          'important'
        );
        elements.panel.style.setProperty('transform', 'translateX(100%)', 'important');
        elements.backdrop.style.setProperty('opacity', '0', 'important');
      }

      closeTimer = window.setTimeout(function () {
        drawer.setAttribute('aria-hidden', 'true');
        setVisualRestingState(false);
        syncOpenState(false);

        if (restoreFocus && lastTrigger && document.contains(lastTrigger)) {
          lastTrigger.focus({ preventScroll: true });
        }
      }, openDuration);
    }

    function toggleDrawer(trigger) {
      if (drawer.getAttribute('aria-hidden') === 'false') {
        closeDrawer(true);
      } else {
        openDrawer(trigger);
      }
    }

    var drawerObserver = new MutationObserver(function (records) {
      var stateChanged = records.some(function (record) {
        return record.type === 'attributes' && record.attributeName === 'aria-hidden';
      });

      if (stateChanged) {
        syncOpenState(false);
      }
    });

    drawerObserver.observe(drawer, {
      attributes: true,
      attributeFilter: ['aria-hidden']
    });

    function announce(message) {
      var status = drawer.querySelector('[data-hesatek-cart-status]');
      if (!status) {
        return;
      }

      status.textContent = '';
      window.requestAnimationFrame(function () {
        status.textContent = message || '';
      });
    }

    function cartEndpoint(name) {
      var value = drawer.getAttribute(name);
      if (value) {
        return value;
      }

      if (name === 'data-cart-change-url') {
        return '/cart/change';
      }

      if (name === 'data-cart-add-url') {
        return '/cart/add';
      }

      return '/cart';
    }

    function updateHeaderCount(itemCount) {
      document.querySelectorAll('.header__cart-count').forEach(function (count) {
        count.textContent = itemCount;
      });
    }

    function focusAfterRefresh(focusState) {
      if (!focusState) {
        return;
      }

      var controls = Array.prototype.slice.call(drawer.querySelectorAll('[data-line-key]'));
      var nextControl = controls.find(function (control) {
        return control.getAttribute('data-line-key') === focusState.key &&
          control.getAttribute('data-action') === focusState.action &&
          !control.disabled;
      });

      if (!nextControl) {
        nextControl = controls.find(function (control) {
          return Number(control.getAttribute('data-line')) === focusState.line && !control.disabled;
        });
      }

      nextControl = nextControl || drawer.querySelector('[data-hesatek-cart-initial-focus]');

      if (nextControl) {
        nextControl.focus({ preventScroll: true });
      }
    }

    function focusProductAfterRefresh(productId) {
      if (!productId) {
        return;
      }

      var product = drawer.querySelector('.mini-cart__line-item[data-product-id="' + productId + '"]');
      var productLink = product && product.querySelector('.mini-cart__product-title');

      if (productLink) {
        productLink.focus({ preventScroll: false });
      }
    }

    function applyDrawerHtml(html, options) {
      var settings = options || {};
      var shell = document.createElement('div');
      shell.innerHTML = html;
      var nextDrawer = shell.querySelector('#mini-cart');

      if (!nextDrawer) {
        throw new Error('Cart section did not contain #mini-cart');
      }

      var wasOpen = drawer.getAttribute('aria-hidden') === 'false';
      var scrollContainer = drawer.querySelector('.mini-cart__line-item-list');
      var scrollTop = scrollContainer ? scrollContainer.scrollTop : 0;

      closeRecommendationPicker(false, true);
      drawer.innerHTML = nextDrawer.innerHTML;
      drawer.setAttribute('data-item-count', nextDrawer.getAttribute('data-item-count') || '0');
      drawer.setAttribute('data-cart-url', nextDrawer.getAttribute('data-cart-url') || cartEndpoint('data-cart-url'));
      drawer.setAttribute('data-cart-add-url', nextDrawer.getAttribute('data-cart-add-url') || cartEndpoint('data-cart-add-url'));
      drawer.setAttribute('data-cart-change-url', nextDrawer.getAttribute('data-cart-change-url') || cartEndpoint('data-cart-change-url'));

      var itemCount = Number(drawer.getAttribute('data-item-count')) || 0;
      updateHeaderCount(itemCount);

      if (wasOpen) {
        drawer.setAttribute('aria-hidden', 'false');
        setVisualRestingState(true);
        syncOpenState(false);
      } else if (settings.openAfter) {
        drawer.setAttribute('aria-hidden', 'true');
        setVisualRestingState(false);
        openDrawer(lastTrigger);
      }

      var nextScrollContainer = drawer.querySelector('.mini-cart__line-item-list');
      if (nextScrollContainer && !settings.openAfter) {
        nextScrollContainer.scrollTop = scrollTop;
      }

      if (cartHost) {
        cartHost.dispatchEvent(new CustomEvent('cart:rerendered', { bubbles: true }));
      }

      if (wasOpen) {
        if (settings.focusProductId) {
          focusProductAfterRefresh(settings.focusProductId);
        } else {
          focusAfterRefresh(settings.focusState);
        }
      }
    }

    function refreshDrawer(options) {
      var settings = options || {};
      var sectionUrl = new URL(cartEndpoint('data-cart-url'), window.location.origin);
      sectionUrl.searchParams.set('section_id', 'mini-cart');

      return fetch(sectionUrl.toString(), {
        credentials: 'same-origin',
        method: 'GET',
        headers: {
          'Cache-Control': 'no-cache',
          'X-Requested-With': 'XMLHttpRequest'
        }
      })
        .then(function (response) {
          if (!response.ok) {
            throw new Error('Cart section HTTP ' + response.status);
          }
          return response.text();
        })
        .then(function (html) {
          applyDrawerHtml(html, settings);
        });
    }

    function quantityError(error, fallbackValue) {
      var input = drawer.querySelector('.quantity-selector__value[data-line="' + fallbackValue.line + '"]');
      if (input) {
        input.value = input.getAttribute('data-current-value') || input.value;
      }

      announce(error && error.message ? error.message : '');
      console.error('[Hesatek cart drawer]', error);
    }

    function queueCartOperation(operation, onError) {
      pendingOperations += 1;
      setBusy(true);

      operationQueue = operationQueue
        .catch(function () {
          // Keep the queue usable after a previous operation failed.
        })
        .then(operation)
        .catch(onError)
        .then(function () {
          pendingOperations -= 1;
          setBusy(pendingOperations > 0);
        });

      return operationQueue;
    }

    function updateQuantity(control, quantity) {
      if (pendingOperations > 0) {
        return;
      }

      var line = Number(control.getAttribute('data-line'));
      var nextQuantity = Number(quantity);

      if (!Number.isFinite(line) || line < 1 || !Number.isFinite(nextQuantity) || nextQuantity < 0) {
        return;
      }

      var action = control.getAttribute('data-action') || 'decrease-quantity';
      var focusState = {
        line: line,
        key: control.getAttribute('data-line-key') || '',
        action: action
      };
      announce('');

      queueCartOperation(function () {
        return fetch(cartEndpoint('data-cart-change-url') + '.js', {
          body: JSON.stringify({ line: line, quantity: nextQuantity }),
          credentials: 'same-origin',
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'X-Requested-With': 'XMLHttpRequest'
          }
        })
          .then(function (response) {
            return response.json().then(function (payload) {
              if (!response.ok) {
                throw new Error(payload.description || payload.message || ('Cart change HTTP ' + response.status));
              }
              return payload;
            });
          })
          .then(function (cart) {
            updateHeaderCount(cart.item_count || 0);
            return refreshDrawer({ focusState: focusState });
          });
      }, function (error) {
          quantityError(error, { line: line });
      });
    }

    function setRecommendationIconState(control, state) {
      if (!control) {
        return;
      }

      var plusIcon = control.querySelector('.hesatek-cart-recommendations__action-icon--plus');
      var checkIcon = control.querySelector('.hesatek-cart-recommendations__action-icon--check');
      var showCheck = state === 'added';

      if (plusIcon) {
        plusIcon.hidden = showCheck;
        if (showCheck) {
          plusIcon.style.display = 'none';
        } else {
          plusIcon.style.removeProperty('display');
        }
      }

      if (checkIcon) {
        checkIcon.hidden = !showCheck;
        if (showCheck) {
          checkIcon.style.removeProperty('display');
        } else {
          checkIcon.style.display = 'none';
        }
      }
    }

    function recommendationError(error, control) {
      if (control && document.contains(control)) {
        control.disabled = false;
        control.removeAttribute('aria-disabled');
        control.removeAttribute('aria-busy');
        control.classList.remove('is-adding', 'is-added');
        setRecommendationIconState(control, 'idle');
      }

      var message = error && error.message ? error.message : '';
      var picker = control && control.closest('.hesatek-cart-picker');
      var pickerError = picker && picker.querySelector('[data-hesatek-cart-picker-error]');

      if (pickerError) {
        pickerError.textContent = message;
        pickerError.hidden = false;
      }

      announce(message);
      console.error('[Hesatek cart drawer]', error);
    }

    function addRecommendation(control) {
      if (pendingOperations > 0) {
        return;
      }

      var variantId = Number(control.getAttribute('data-variant-id'));
      var quantity = Number(control.getAttribute('data-quantity'));
      var productId = control.getAttribute('data-product-id') || '';
      var addedMessage = control.getAttribute('data-added-message') || '';
      var isQuickAdd = control.matches(
        '[data-hesatek-cart-recommendation-add][data-requires-choice="false"]'
      );

      if (!Number.isFinite(variantId) || variantId < 1 ||
          !Number.isFinite(quantity) || quantity < 1 || !productId) {
        return;
      }

      quantity = Math.floor(quantity);

      control.disabled = true;
      control.setAttribute('aria-disabled', 'true');
      if (isQuickAdd) {
        control.classList.remove('is-added');
        setRecommendationIconState(control, 'idle');
        control.classList.add('is-adding');
        control.setAttribute('aria-busy', 'true');
      }
      announce('');

      queueCartOperation(function () {
        return fetch(cartEndpoint('data-cart-add-url') + '.js', {
          body: JSON.stringify({
            items: [{ id: variantId, quantity: quantity }],
            sections: 'mini-cart',
            sections_url: window.location.pathname
          }),
          credentials: 'same-origin',
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'X-Requested-With': 'XMLHttpRequest'
          }
        })
          .then(function (response) {
            return response.json().then(function (payload) {
              if (!response.ok) {
                throw new Error(payload.description || payload.message || ('Cart add HTTP ' + response.status));
              }
              return payload;
            });
          })
          .then(function (payload) {
            var sectionHtml = payload.sections && payload.sections['mini-cart'];

            if (window.theme.pageType !== 'cart') {
              control.dispatchEvent(new CustomEvent('product:added', {
                bubbles: true,
                detail: {
                  button: control,
                  variant: null,
                  quantity: quantity,
                  hesatekDrawerAlreadyRendered: true,
                  source: 'cart-recommendation'
                }
              }));
            }

            if (isQuickAdd && document.contains(control)) {
              control.classList.remove('is-adding');
              control.removeAttribute('aria-busy');
              setRecommendationIconState(control, 'added');
              void control.offsetWidth;
              control.classList.add('is-added');
            }

            return new Promise(function (resolve) {
              window.setTimeout(resolve, isQuickAdd ? recommendationFeedbackDuration : 0);
            }).then(function () {
              if (typeof sectionHtml === 'string' && sectionHtml) {
                applyDrawerHtml(sectionHtml, { focusProductId: productId });
                return;
              }

              return refreshDrawer({ focusProductId: productId });
            });
          })
          .then(function () {
            announce(addedMessage);
          });
      }, function (error) {
        recommendationError(error, control);
      });
    }

    document.addEventListener('click', function (event) {
      var toggle = event.target.closest('[data-action="toggle-mini-cart"][aria-controls="mini-cart"]');

      if (toggle) {
        event.preventDefault();
        event.stopPropagation();
        toggleDrawer(drawer.contains(toggle) ? lastTrigger : toggle);
        return;
      }

      var pickerBack = event.target.closest(
        '.hesatek-cart-drawer [data-hesatek-cart-picker-back]'
      );

      if (pickerBack) {
        event.preventDefault();
        event.stopPropagation();
        closeRecommendationPicker(true, false);
        return;
      }

      var recommendationAdd = event.target.closest(
        '.hesatek-cart-drawer [data-hesatek-cart-recommendation-add]'
      );

      if (recommendationAdd) {
        event.preventDefault();
        event.stopPropagation();
        if (recommendationAdd.getAttribute('data-requires-choice') === 'true') {
          openRecommendationPicker(recommendationAdd);
        } else {
          addRecommendation(recommendationAdd);
        }
        return;
      }

      var pickerDecrease = event.target.closest(
        '.hesatek-cart-drawer [data-hesatek-cart-picker-decrease]'
      );
      var pickerIncrease = event.target.closest(
        '.hesatek-cart-drawer [data-hesatek-cart-picker-increase]'
      );

      if (pickerDecrease || pickerIncrease) {
        event.preventDefault();
        event.stopPropagation();
        adjustPickerQuantity(pickerIncrease ? 1 : -1);
        return;
      }

      var pickerConfirm = event.target.closest(
        '.hesatek-cart-drawer [data-hesatek-cart-picker-confirm]'
      );

      if (pickerConfirm) {
        event.preventDefault();
        event.stopPropagation();
        syncPickerQuantity(false);
        if (!pickerConfirm.disabled) {
          addRecommendation(pickerConfirm);
        }
        return;
      }

      var quantityControl = event.target.closest(
        '.hesatek-cart-drawer [data-action="increase-quantity"], ' +
        '.hesatek-cart-drawer [data-action="decrease-quantity"]'
      );

      if (!quantityControl || quantityControl.disabled) {
        return;
      }

      event.preventDefault();
      event.stopPropagation();
      updateQuantity(quantityControl, quantityControl.getAttribute('data-quantity'));
    }, true);

    document.addEventListener('change', function (event) {
      var pickerVariant = event.target.closest(
        '.hesatek-cart-drawer [data-hesatek-cart-picker-variant]'
      );

      if (pickerVariant) {
        event.preventDefault();
        event.stopPropagation();
        syncPickerQuantity(true);
        return;
      }

      var pickerQuantity = event.target.closest(
        '.hesatek-cart-drawer [data-hesatek-cart-picker-quantity]'
      );

      if (pickerQuantity) {
        event.preventDefault();
        event.stopPropagation();
        syncPickerQuantity(false);
        return;
      }

      var input = event.target.closest('.hesatek-cart-drawer .quantity-selector__value');
      if (!input) {
        return;
      }

      event.preventDefault();
      event.stopPropagation();
      updateQuantity(input, input.value);
    }, true);

    document.addEventListener('keydown', function (event) {
      if (drawer.getAttribute('aria-hidden') !== 'false') {
        return;
      }

      if (event.key === 'Escape') {
        event.preventDefault();
        event.stopPropagation();
        if (isPickerOpen()) {
          closeRecommendationPicker(true, false);
        } else {
          closeDrawer(true);
        }
        return;
      }

      if (event.key === 'Enter' && event.target.matches('[data-hesatek-cart-picker-quantity]')) {
        event.preventDefault();
        event.stopPropagation();
        syncPickerQuantity(false);
        return;
      }

      if ((event.key === 'ArrowUp' || event.key === 'ArrowDown') &&
          event.target.matches('[data-hesatek-cart-picker-quantity]')) {
        event.preventDefault();
        event.stopPropagation();
        adjustPickerQuantity(event.key === 'ArrowUp' ? 1 : -1);
        return;
      }

      if (event.key === 'Enter' && event.target.matches('.quantity-selector__value')) {
        event.preventDefault();
        event.stopPropagation();
        updateQuantity(event.target, event.target.value);
        return;
      }

      if (event.key !== 'Tab') {
        return;
      }

      var focusable = Array.prototype.filter.call(
        drawer.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), [tabindex]'),
        function (element) {
          return element.getAttribute('tabindex') !== '-1' &&
            element.getAttribute('aria-hidden') !== 'true' &&
            !element.closest('[aria-hidden="true"]') &&
            !element.closest('[inert]') &&
            element.getClientRects().length > 0;
        }
      );

      if (!focusable.length) {
        return;
      }

      var first = focusable[0];
      var last = focusable[focusable.length - 1];

      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    }, true);

    document.addEventListener('focusin', function (event) {
      if (drawer.getAttribute('aria-hidden') !== 'false') {
        return;
      }

      var focusInsidePickerSurface = event.target.closest && event.target.closest(
        '.hesatek-cart-picker, .hesatek-cart-drawer__header'
      );

      if (!drawer.contains(event.target) || (isPickerOpen() && !focusInsidePickerSurface)) {
        focusInitialControl();
      }
    }, true);

    var pendingProductForms = new WeakSet();

    function productFormMessage(form, message, showCartLink) {
      var notice = form.querySelector('[data-hesatek-product-cart-message]');
      if (!notice) {
        notice = document.createElement('p');
        notice.setAttribute('data-hesatek-product-cart-message', '');
        notice.setAttribute('role', 'alert');
        form.appendChild(notice);
      }
      notice.textContent = message;
      notice.hidden = !message;
      if (showCartLink) {
        var link = document.createElement('a');
        link.href = cartEndpoint('data-cart-url');
        link.textContent = drawer.getAttribute('data-cart-view-label');
        notice.appendChild(document.createTextNode(' '));
        notice.appendChild(link);
      }
    }

    function submitProductForm(event) {
      var form = event.target;
      if (window.theme.pageType !== 'product' || event.defaultPrevented ||
          !(form instanceof HTMLFormElement) || drawer.contains(form)) {
        return;
      }
      var action = new URL(form.action, window.location.href);
      var addUrl = new URL(cartEndpoint('data-cart-add-url'), window.location.origin);
      if (form.method.toLowerCase() !== 'post' || action.origin !== addUrl.origin ||
          action.pathname.replace(/\/$/, '') !== addUrl.pathname.replace(/\/$/, '')) {
        return;
      }
      var trigger = event.submitter || form.querySelector('[type="submit"]');
      if (trigger && (trigger.name === 'checkout' || trigger.closest('.shopify-payment-button'))) {
        return;
      }
      event.preventDefault();
      event.stopImmediatePropagation();
      if (pendingProductForms.has(form) || (trigger && trigger.disabled) || !form.reportValidity()) {
        return;
      }
      var body = new FormData(form);
      var requestedQuantity = Number(body.get('quantity') || 1);
      body.set('sections', 'mini-cart');
      body.set('sections_url', window.location.pathname);
      var controls = Array.prototype.slice.call(form.querySelectorAll('button[type="submit"], input[type="submit"]'));
      var disabledStates = controls.map(function (control) { return control.disabled; });
      var oldBusy = form.getAttribute('aria-busy');
      pendingProductForms.add(form);
      form.setAttribute('aria-busy', 'true');
      controls.forEach(function (control) { control.disabled = true; });
      productFormMessage(form, '', false);
      lastTrigger = trigger;
      var added = false;

      queueCartOperation(function () {
        return fetch(addUrl.toString().replace(/\/$/, '') + '.js', {
          method: 'POST',
          credentials: 'same-origin',
          headers: { 'X-Requested-With': 'XMLHttpRequest' },
          body: body
        }).then(function (response) {
          if (response.ok) added = true;
          return response.json().then(function (payload) {
            if (!response.ok) {
              throw new Error(typeof payload.description === 'string' ? payload.description :
                drawer.getAttribute('data-cart-add-error'));
            }
            return payload;
          });
        }).then(function (payload) {
          var variant = payload.items ? payload.items[0] : payload;
          form.dispatchEvent(new CustomEvent('product:added', {
            bubbles: true,
            detail: {
              button: trigger,
              variant: variant,
              quantity: requestedQuantity,
              hesatekDrawerAlreadyRendered: true
            }
          }));
          var html = payload.sections && payload.sections['mini-cart'];
          if (typeof html === 'string' && html) {
            try {
              applyDrawerHtml(html, { openAfter: true });
              return;
            } catch (error) {
              return refreshDrawer({ openAfter: true });
            }
          }
          return refreshDrawer({ openAfter: true });
        });
      }, function (error) {
        productFormMessage(form, added ? drawer.getAttribute('data-cart-refresh-error') :
          (error instanceof TypeError ? drawer.getAttribute('data-cart-add-error') :
            error.message || drawer.getAttribute('data-cart-add-error')), true);
      }).finally(function () {
        pendingProductForms.delete(form);
        if (oldBusy === null) form.removeAttribute('aria-busy');
        else form.setAttribute('aria-busy', oldBusy);
        var currentVariant = new FormData(form).get('id');
        if (currentVariant === body.get('id')) {
          controls.forEach(function (control, index) { control.disabled = disabledStates[index]; });
        }
      });
    }

    document.addEventListener('submit', submitProductForm, true);

    // The cart page keeps Warehouse's full-page rerendering contract. On all
    // other pages this asset owns the drawer refresh and auto-open lifecycle.
    if (window.theme.pageType !== 'cart') {
      document.documentElement.addEventListener('product:added', function (event) {
        if (event.detail && event.detail.hesatekDrawerAlreadyRendered) {
          return;
        }

        queueCartOperation(function () {
          return refreshDrawer({ openAfter: true });
        }, function (error) {
          quantityError(error, { line: 0 });
        });
      });

      document.documentElement.addEventListener('cart:refresh', function () {
        queueCartOperation(function () {
          return refreshDrawer();
        }, function (error) {
          quantityError(error, { line: 0 });
        });
      });
    }

    function suppressKaktusDrawer() {
      var app = document.getElementById('kaktusc-app');
      var widget = document.getElementById('kaktusc-widget');
      var nodes = [app, widget].filter(Boolean);

      nodes.forEach(function (node) {
        node.hidden = true;
        node.setAttribute('aria-hidden', 'true');

        if ('inert' in node) {
          node.inert = true;
        }
      });

      return nodes.length > 0;
    }

    if (!suppressKaktusDrawer()) {
      var kaktusObserver = new MutationObserver(function () {
        if (suppressKaktusDrawer()) {
          kaktusObserver.disconnect();
        }
      });

      kaktusObserver.observe(document.body, {
        childList: true,
        subtree: true
      });

      window.setTimeout(function () {
        kaktusObserver.disconnect();
      }, 15000);
    }

    setVisualRestingState(drawer.getAttribute('aria-hidden') === 'false');
    syncOpenState(false);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initHesatekCartDrawer, { once: true });
  } else {
    initHesatekCartDrawer();
  }
})();

